export const LADE_AUSWAHLWERTE_ZEITERFASSUNG = "ladeAuswahlwerteZeiterfassung";
